const LOCAL_STORAGE_KEY = 'user-theme';

type Theme = 'light' | 'dark';

export function updateTheme(theme: Theme) {
  localStorage.setItem(LOCAL_STORAGE_KEY, theme);
  applyTheme(theme);
}

export function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function getTheme() {
  return localStorage.getItem(LOCAL_STORAGE_KEY) as Theme | null;
}

export function loadTheme() {
  let theme = getTheme();
  if (!theme) {
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
    theme = systemTheme as Theme;
  }
  if (theme) {
    applyTheme(theme);
  }
  return theme;
}
